import { BuildingItemModel } from "./buildingItem.model";
import { SiteWithPhotoModel } from "../../shared/models/site-with-photo.model";

export class SiteModel extends SiteWithPhotoModel {
  constructor(
    public id: string,
    public name: string,
    public address: string,
    public hasOutdoorAreas: boolean,
    public buildings: BuildingItemModel[],
    public rentalArea: null | string,
    public tenantCount: null | string,
    public lastRehabilitationDate: null | string,
    public floorCount: null | string,
    public ownerType: null | string,
    public isOffline: boolean,
    public isGraphic: boolean,
    public isExported: boolean,
    public numberOfExportedBuildings: number,
    public numberOfBuildings: number,
    public numberOfAnnotations: number,
    public numberOfAnnotationsOnArea: number
  ) {
    super(id);
  }
}
